
import { useTranslation } from 'react-i18next';
import { Document, Image, Page, PDFDownloadLink, StyleSheet, Text, View } from '@react-pdf/renderer';
import AwayterLogo from '../../utils/resources/awayter_connect_light_cropped.png'
import './3DTest.scss'

const styles = StyleSheet.create({
    page: {
        padding: 20
    },
    container: {
        marginLeft: 20,
        marginBottom: 20,
    },
    header: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        backgroundColor: '#25384a',
        padding: 10,
        marginBottom: 5,
        color: 'white'
    },
    title: {
        fontSize: 16,
        fontWeight: 800
    },
    subtitle: {
        fontSize: 14,
        fontWeight: 800
    },
    titleWithOutColor: {
        fontSize: 15,
        fontWeight: 800,
        marginBottom: 5,
    },
    logo: {
        width: 100
    },
    content: {
        fontSize: 12,
        fontWeight: 800,
        marginBottom: 5,
        marginTop: 5
    },
    tableContainer: {
        width: 500,
        fontSize: 12,
        marginBottom: 20,
        justifyContent: 'center',
        alignSelf: 'center'
    },
    tableHeader: {
        flexDirection: 'row',
        backgroundColor: '#f0f0f0',
        padding: 8,
        borderBottomWidth: 1,
        borderBottomColor: '#000',
    },
    tableRow: {
        flexDirection: 'row',
        padding: 8,
        borderBottomWidth: 1,
        borderBottomColor: '#000',
    },
    tableCell: {
        flex: 0.5,
    },
    tableCellCol: {
        flex: 1
    },
});


const MyDocument = (props: { modelImgUrl: string }) => {
    const { t } = useTranslation()

    return (
        <Document>
            <Page style={styles.page}>
                <View style={styles.header}>
                    <View>
                        <Text style={styles.title}>{'Model 12VAD856YSU25'}</Text>
                    </View>
                    <View>
                        <Image src={AwayterLogo} style={styles.logo} />
                    </View>
                </View>
                <View style={styles.container}>
                    <Text style={styles.content}>{`${t('Client')}: Awayter`}</Text>
                    <Text style={styles.content}>{`${t('Date')}: 26/11/2025`}</Text>
                </View>
                <View style={styles.header}>
                    <Text style={styles.titleWithOutColor}>{t('Data')}</Text>
                </View>
                <View style={styles.tableContainer}>

                    <View style={styles.tableRow}>
                        <Text style={styles.tableCellCol}>{t('Serial number')}</Text>
                        <Text style={styles.tableCell}>{'12VAD856YSU25'}</Text>
                    </View>
                    <View style={styles.tableRow}>
                        <Text style={styles.tableCellCol}>{t('Model')}</Text>
                        <Text style={styles.tableCell}>{'Table 00598FD'}</Text>
                    </View>
                    <View style={styles.tableRow}>
                        <Text style={styles.tableCellCol}>{t('Material code')}</Text>
                        <Text style={styles.tableCell}>{'251DD56E'}</Text>
                    </View>
                    <View style={styles.tableRow}>
                        <Text style={styles.tableCellCol}>{t('Start print')}</Text>
                        <Text style={styles.tableCell}>{'26/11/2025 16:54'}</Text>
                    </View>
                    <View style={styles.tableRow}>
                        <Text style={styles.tableCellCol}>{t('End print')}</Text>
                        <Text style={styles.tableCell}>{'26/11/2025 20:38'}</Text>
                    </View>
                    <View style={styles.tableRow}>
                        <Text style={styles.tableCellCol}>{t('Printing time')}</Text>
                        <Text style={styles.tableCell}>{'03:42 h'}</Text>
                    </View>
                    <View style={styles.tableRow}>
                        <Text style={styles.tableCellCol}>{t('Number of points')}</Text>
                        <Text style={styles.tableCell}>{'14.847'}</Text>
                    </View>
                </View>
                <View style={styles.header}>
                    <Text style={styles.titleWithOutColor}>{t('Model')}</Text>
                </View>
                <View style={styles.container}>
                    <Image src={props.modelImgUrl} />
                </View>
            </Page>

        </Document>

    )
};

const ReportingPdfDownload = (props: { modelImgUrl: string }) => {

    return (
        <div className='downloadButton mt-1 w-25 btn-Custom btn-IDGreen' style={{ color: 'var(--text-primary)' }}>
            <PDFDownloadLink document={<MyDocument modelImgUrl={props.modelImgUrl} />}><i className="bi bi-arrow-down"></i> Datasheet</PDFDownloadLink>
        </div>
    );
};

export default ReportingPdfDownload;
